import PropTypes from 'prop-types'

import clsx from 'clsx'
import { MenuItem, Typography, Select, InputLabel } from '@mui/material'

const MultiLineSelect = ({ options, value, onChange, isFullWidth, label }) => {
  return (
    <>
      {Boolean(label) && Boolean(!isFullWidth) ? (
        <InputLabel sx={{ pl: 2 }}>{label}</InputLabel>
      ) : null}
      <Select
        value={value}
        id="clientCenterCode"
        name="clientCenterCode"
        onChange={onChange}
        className={clsx('multiLineSelect', {
          'is-fullWidth': isFullWidth,
        })}
        MenuProps={{
          classes: {
            paper: clsx('select-menu select-menuMultiline', {
              'is-fullWidth': isFullWidth,
            }),
          },
        }}
      >
        {options.length
          ? options.map(clientCenter => (
              <MenuItem
                disabled={clientCenter?.status !== 'ACTIVE'}
                key={clientCenter.id}
                value={`${clientCenter.id}`}
                className="multiLineSelect-menuItem"
              >
                <Typography className="multiLineSelect-menuItemInfo">
                  <Typography
                    variant="h3medium"
                    className="multiLineSelect-clientCenterName"
                  >
                    {clientCenter.name}
                  </Typography>
                  <Typography
                    variant="h3medium"
                    className="multiLineSelect-clientCenterId"
                  >
                    {clientCenter.id}
                  </Typography>
                </Typography>
              </MenuItem>
            ))
          : null}
      </Select>
    </>
  )
}

MultiLineSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ),
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  isFullWidth: PropTypes.bool,
  label: PropTypes.string,
}

export default MultiLineSelect
